import { render } from "./Activity.vue?vue&type=template&id=6cf5cd0e"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"

import "./Activity.vue?vue&type=style&index=0&id=6cf5cd0e&lang=scss"
script.render = render

export default script